import store from "@/store";
import Trimaster from "@/plugins/servers/trimaster";
import vuetifyToast from "@/vuetifyToast.js";
import { EventBus } from "@/event-bus.js";

const env = process.env;
const chunkSize = 1*1024*1024; // Max chunk size in MB

export default class ChunkedFileUploader {

  imageUploadInfo;
  chunkCounter = 0;
  numberOfChunks = 1;
  fileName;
  fileUrl;
  uploadUrl;
  uploadWorkers = [];
  workerResponseCount = 0;

  constructor(imageUploadInfo) {
    this.imageUploadInfo = imageUploadInfo;
    this.imageUploadInfo.chunkSize = this.imageUploadInfo.chunkSize ? this.imageUploadInfo.chunkSize : chunkSize;
  }

  async uploadFile(file) {
    let originalName = file.name.split(".");

    let blob = file.slice(0, file.size, file.type);
    let imagePart = `${this.imageUploadInfo.name}`;
    this.fileName = `${env.VUE_APP_trimaster}-${imagePart}-${
      file.name.split(".")[0]
    }-${Math.random().toString(36).substring(7)}-${store.getters['getUser'].id}.${
      originalName[originalName.length - 1]
    }`;
    file = new File(
      [blob],
      this.fileName,
      { type: file.type }
    );

    const uploadUrlPieces = this.imageUploadInfo.uploadUrl.split('/');
    this.uploadUrl = uploadUrlPieces.length > 1 ? uploadUrlPieces[0] : this.imageUploadInfo.uploadUrl;
    this.numberOfChunks = Math.ceil(file.size / this.imageUploadInfo.chunkSize);
    let [fileUrl, err] = await Trimaster.post(this.uploadUrl+'/chunkedS3Initialize', store.getters['getUser'].apitoken, {
      filename: this.fileName,
      bucket: this.imageUploadInfo.bucketName,
      totalChunks: this.numberOfChunks,
      fileType: file.type
    })
    this.fileUrl = fileUrl;

    while (this.chunkCounter < this.numberOfChunks) {
      this.createChunk(file)
    }

    return fileUrl;
  }

  createChunk(file) {
    let start = this.imageUploadInfo.chunkSize * this.chunkCounter;
    this.chunkCounter++;
    const chunkEnd = Math.min(start + this.imageUploadInfo.chunkSize , file.size);
    const chunk = file.slice(start, chunkEnd);

    const chunkData = {
      totalChunks: this.numberOfChunks,
      chunkNumber: this.chunkCounter,
      bucketName: this.imageUploadInfo.bucketName,
      originalFileName: this.fileName,
      finalFileUrl: this.fileUrl,
      fileChunk: chunk,
      fileType: file.type
    };

    this.uploadChunk(chunkData);
  }

  uploadChunk(chunkForm) {
    let uploadWorker = new Worker('/workers/upload-worker.js');
    let me = this;
    uploadWorker.onmessage = function(message) {
      me.handleWorkerMessage(message);
    };
    uploadWorker.postMessage({
      chunk: chunkForm,
      uploadUrl: env.VUE_APP_trimaster+'/api/v1/'+this.uploadUrl+'/chunkedS3Upload',
      apitoken: store.getters['getUser'].apitoken
    })
    this.uploadWorkers.push(uploadWorker);
  }

  handleWorkerMessage(message) {
    switch(message.data.type) {
      case 'success':
        this.workerResponseCount++;
        if (this.workerResponseCount === this.uploadWorkers.length) {
          this.triggerFileMerge()
        }
        break;
      default:
        console.log('worker message', message.data.content)
    }
  }

  async triggerFileMerge() {
    await Trimaster.post(this.uploadUrl+'/chunkedS3Merge', store.getters['getUser'].apitoken, {
      finalFileUrl: this.fileUrl,
    })

    this.uploadWorkers.forEach(uploadWorker => {
      uploadWorker.terminate();
    })
    this.uploadWorkers = [];
    EventBus.$emit("chunkedUploadComplete", this.fileUrl);
    vuetifyToast.success(`Finished uploading file`);
  }
}
